const NO_ORG_NETWORK_IDS = [0, -1];

// 0 and -1 mean "no org selected yet". Other negative ids are valid duplicate
// staging accounts, so exclude only these two sentinels.
export const isValidNetworkId = (networkId?: number): boolean => typeof networkId === 'number' && !NO_ORG_NETWORK_IDS.includes(networkId);
